import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oci-auth',
  templateUrl: './oci-auth.component.html',
  styleUrls: ['./oci-auth.component.css']
})
export class OciAuthComponent implements OnInit {


  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }



  requestData =`
   {
    "tenancy_ocid":"XXX", 
    "user_ocid":"XXX", 
    "fingerprint":"XXX",  
    "region":"us-ashburn-1",
    "bucket_name":"test-optimus-video-bt",
    "namespace":"abcd4rx",
    "private_key":"private key data"
    }
    `


  Data= `

    "private_key": "MIIEvQIBADANBgkqhkAQCf332aezkQVW0j\r\ntqyI6j3eq5AFY9R8FDbrQRz7hveTq1A6Gc0zEFFNT5PeFm7sFNT3WwIcnk9DUs4H\r\n8gIBbD0brA616xAUgbng3fHUbCY6Dbrp5wHEtIAZXetTi85NMSZYdKobDKfDccwC\r\n7VLM8wzUKJPbkxIqNL7+SjIGEA6Ez1w6ri08hYWzHo0assxS2EXSJJP8nrrhcD49\r\npxSF2DcAkTPWG08ROSyTAApWrCqFlI9fmVcPHeEOan8WCbZJUrXEKtbh80GIp/NL\r\n5M7oUqsDZ9JIQftA5Bb+oR3oaTf8BtUuxm6zN7eLq7zFGcuRc5daFeoI3lRlhW2+\r\ngUU+Atr7AgMBAAECggEASGfuWXQ8bG7cLqQRsTKxkbMO17oWZpm7I8IKL8q5PyqD\r\n+8RqwJk/0S1c0WVEmGx45YxUwQRb7qhGgqezC9TrOiirQu3yiu8T8cljOKtAhuNo\r\nB35luSJsr9Bu/5ged6xuavpvfi+1nVlhJeQ5L3RWl5HHIVeTDwVziPSugjtsb+5I\r\n3FyhMrZebJ2dYi2w8pQyHtAD/6Wy5Odkj9b0FKUWS2MuybSCtUsmHUizy2STS/iv\r\nih3VZkVthyKCDUp5CxSnNVxqjJc5LYnGSszc3uNNWco/EfMJwcqeUWwVM+24QXYX\r\nNFip3ercITK4X12CrrojkrY3QUOeAwzTPhK9QCnjWQKBgQDLzWZfgQeezzgy6biF\r\n1ZOgYgI6Oan8omuM7wburZ2aV4bQoVIpONaq19iUKq7X1jbW9R8fsT1wXM6eIkxo\r\nYFwBOtqueCo/O1yM8+C722pKFqLHqMyisuNltfGyeX1An/FFzez6/FwNYSrLG71T\r\nI6sl+1Vl/dYXrK2xiUqVNPk+SQKBgQDI0cyqWIU+rc3ZVkrpq41s/gaLqwqyjeHH\r\ngFXGp7MSeO1AR9cCQIF+FVQ9zY+ZhEEynppkLkgc/i4y1HynTEuEBFIEbhl/oeah\r\n2Kr8gLVeb5DDSxNjBtw2acnYZD2Pf0DqgD2qzh4SXOrjKZErDGnoM3PYU2eihTK+\r\nHEvjoECfIwKBgGZKm/2Hh8mf/HchdCpIfqZbSv7qfnV9GDpOps4ZeidDkzkYH2Lt\r\nUmHBoMUNf2B59mCB+7MuhMXm7xXT5UHmS4eagLRdP+co5lUg+0WO5ZR2NBG+mad3\r\n3kbowX1xGPrczH7a0v1OuO1GPfJf4/Dc0ERqF/zvIQwU8cFQRY0KX6dxAoGBAIZ9\r\nCqXiVondeAhfZBgNjc86aEPNLoLZxiUHa2p5ENIELk9oTTPy40X/HsWtDshu7ALs\r\neNUysZTJHUNpTnnz/HbTNeJFocn6MSyeoBQuVkiCSt6fPsKI6519R3Il35xkSqNB\r\ncwsassT1eVDcm53K2HprSt/LK5KJxavP43rz7ZMlAoGAUoslFUZ6nyEVLObaJ630\r\nxc88teKIbT6ARBVYEVPTSAsq0cqrSGsjI+hAWV45+ML2kqiBitAv6C9j2lSgB0P8\r\nZPJmmSPhenyoiOxcqEuo1/scJXoyZ0BtNV8GDiMhV78wO6ZsiwVcmXKUZ+bHBQvG\r\nDjdh3GECWHfaL337AZt9v10=\r\n" <br>
  }`



  sucessData =`
  {
    "data":null,
    "message":"OCI authenticated successfully"
  }
  `

  Error5x =`
  {
    "error": {},
    "message": "string"
  }
  `
  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }



}
